// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pe_a bhc_cw bhc_jx bhc_jo bhc_a bhc_j bhc_ri bhc_rj","SearchPanel__icon":"pe_b bhc_ui bhc_hb bhc_ro bhc_tu","SearchPanel__input":"pe_c bhc_iv bhc_cx bhc_z"};